import React from 'react';
import "./Careers.css";
import { Link, useHistory } from "react-router-dom";
import { db } from './firebase';
import emailjs from 'emailjs-com';

function Careers() {
    const history = useHistory();

    // const saveAnswer = (event) => {
    //     event.preventDefault();

    //     const elementsArray = [...event.target.elements];

    //     const formData = elementsArray.reduce((accumulator, currentValue) => {
    //         if (currentValue.id) {
    //             accumulator[currentValue.id] = currentValue.value;
    //         }

    //         return accumulator;
    //     }, {});

    //     db.collection('Hotels').add(formData);

    //     history.replace('/thankyou')
    // }

    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('service_kzfr4aj', 'template_ixlzzio', e.target, 'user_sysI4tmJQHgscIKlmZAji')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
        
          e.target.reset()

          history.replace('/thankyou')
    }
    

    return (
        <div className="careers">
            
            <Link to="/">
                <img 
                className="careers__title"
                src="images/Login_logo.png"></img>
            </Link>

            <div className="careers__container">
                <form onSubmit={sendEmail}>
                    <h3>Careers</h3>
                    <h3>REGISTER YOUR RESTAURANT HERE</h3>
                    <h3>Your Restaurant Name</h3>
                    <input type="text" size="42" name="name" required></input>
                    <h3>Restaurant Address</h3>
                    <input type="text" size="42" name="add" required></input>
                    <h3>Restaurant/Owner Contact No.</h3>
                    <input type="text" size="42" name="contact" required></input>
                    <h3>Restaurant/Owner Email ID</h3>
                    <input type="text" size="42" name="email" required></input>
                    <button className="career_btn">Submit</button>
                </form>
            </div>
        </div>
    )
}

export default Careers
